import React from 'react';
import DC from '../../common/DataConnector';
import { i18n } from '../../lang/i18n';
import { reducerUserLoad } from '../../store/UserData/UserDataReducer';
import { actAlertShow, actLoading, actLoadingEnd } from '../../store/Actions';
import { useAppDispatch, useAppSelector } from '../../store/hooks';

interface Props {
	onSave?: () => void
}

export default function ContactInfoComponent(props: Props) {
    const dispatch = useAppDispatch()
    const userData = useAppSelector((state) => state.userData)
	const [customer, setCustomer] = React.useState<any>({
		name: userData.preferences.contactName,
		phone: userData.preferences.contactPhone
	});
	const [hasChanges, setHasChanges] = React.useState(false);

	async function onSaveContact() {
		if (customer.name.length < 4) {
			actAlertShow(dispatch,"danger", i18n.Errors.ContactNameInfo, 3);
			return;
		}
		if (customer.phone.length < 9) {
			actAlertShow(dispatch,"danger", i18n.Errors.ContactPhoneInfo, 3);
			return;
		}
		actLoading(dispatch)
		const postData: any = {
			name: customer.name,
			phone: customer.phone
		}
		const result = await DC.Patch('/customer/account', postData);
		if (result.wasOk) {
			setHasChanges(false)
			const preferences = userData.preferences;
			preferences.contactName = customer.name;
			preferences.contactPhone = customer.phone;
			dispatch(reducerUserLoad({ preferences: preferences }));
			if (props.onSave)
				props.onSave();
		} else {
			actAlertShow(dispatch,"danger", i18n.Errors.ConnectionInfo, 3);
		}
		actLoadingEnd(dispatch)
	}


	return (
		<>
			<div className="form-group row">
				<label style={{ textAlign: 'center' }}>{i18n.CustomerPreferences.ContactInfo}</label>
			</div>
			<div className="form-group row">
				<label className="col-sm-2 col-form-label">{i18n.CustomerPreferences.Name}</label>
				<div className="col-sm-10">
					<input type="text" className="form-control" placeholder={i18n.CustomerPreferences.Name}
						onChange={(e: any) => { setCustomer({ ...customer, name: e.target.value }); setHasChanges(true); }}
						value={customer.name} />
				</div>
			</div>
			<div className="form-group row">
				<label className="col-sm-2 col-form-label">{i18n.CustomerPreferences.Phone}</label>
				<div className="col-sm-10">
					<input type="text" className="form-control" placeholder={i18n.CustomerPreferences.Phone}
						onChange={(e: any) => { setCustomer({ ...customer, phone: e.target.value }); setHasChanges(true); }}
						value={customer.phone} />
				</div>
			</div>
			{hasChanges && <button className='btn'
				onClick={onSaveContact}
			>{i18n.CustomerPreferences.BTNSaveContact}</button>}
		</>
	);
}